import React from 'react';
import TaskList from 'Containers/Task/TaskList';
import TaskAdd from 'Containers/Task/TaskAdd';
import TaskKanban from 'Containers/Task/TaskKanban';
import TaskByClient from 'Containers/Task/TaskByClient';
import SprintPlanning from 'Containers/Task/SprintPlanning';
import SprintList from 'Containers/Task/SprintList';
import TaskUpdatesSprintList from 'Containers/Task/TaskUpdatesSprintList';
import TaskSprintDailyUpdates from 'Containers/Task/TaskSprintDailyUpdates';
import TaskBacklogUnassigned from 'Containers/Task/TaskBacklogUnassigned';
import TaskTypesSetup from 'Containers/Task/TaskTypesSetup';
import SprintUpdatesReport from 'Containers/Task/SprintUpdatesReport';
import MyLeaves from 'Containers/Task/MyLeaves';
import LeaveManagement from 'Containers/Task/LeaveManagement';
import TaskManagementDashboard from 'Containers/Task/TaskManagementDashboard';

const Actions = {
    task_dashboard: {
        view: {
            codenames: [],
            action_code: 'visible_task_dashboard_view',
            is_superuser_action: false,
            name: 'View Task Dashboard',
            label: 'Task Dashboard',
            action: 'sub-menu',
            url: '/task/dashboard',
            component: <TaskManagementDashboard />,
            permission_needed: true,
        },
        name: 'Task Dashboard',
        type: 'Task Management',
    },
    task: {
        view: {
            codenames: [],
            action_code: 'visible_task_view',
            is_superuser_action: false,
            name: 'View Tasks',
            label: 'Task List',
            action: 'sub-menu',
            url: '/task/list',
            component: <TaskList />,
            permission_needed: true,
            associated_urls: ['/task'],
        },
        create: {
            codenames: [],
            action_code: 'visible_task_add',
            is_superuser_action: false,
            name: 'Create Tasks',
            label: 'Task',
            action: 'action-url',
            url: '/task',
            component: <TaskAdd />,
            permission_needed: true,
        },
        update: {
            codenames: [],
            action_code: 'visible_task_change',
            is_superuser_action: false,
            name: 'Update Tasks',
            label: 'Task',
            action: 'action',
            permission_needed: true,
        },
        delete: {
            codenames: [],
            action_code: 'visible_task_delete',
            is_superuser_action: false,
            name: 'Delete Tasks',
            label: 'Task',
            action: 'action',
            permission_needed: true,
        },
        name: 'Task',
        type: 'Task Management',
    },
    task_types_setup: {
        view: {
            codenames: [],
            action_code: 'visible_task_types_setup_view',
            is_superuser_action: false,
            name: 'View Task Types & Stages',
            label: 'Task types & stages',
            action: 'sub-menu',
            url: '/task/task-types',
            component: <TaskTypesSetup />,
            permission_needed: true,
        },
        name: 'Task types & stages',
        type: 'Task Management',
    },
    task_by_client: {
        view: {
            codenames: [],
            action_code: 'visible_task_by_client_view',
            is_superuser_action: false,
            name: 'View Tasks by Clients',
            label: 'Tasks by Clients',
            action: 'sub-menu',
            url: '/task/by-client',
            component: <TaskByClient />,
            permission_needed: true,
        },
        name: 'Tasks by Clients',
        type: 'Task Management',
    },
    sprint_list: {
        view: {
            codenames: [],
            action_code: 'visible_sprint_list_view',
            is_superuser_action: false,
            name: 'View Sprint List',
            label: 'Sprint List',
            action: 'sub-menu',
            url: '/task/sprint/list',
            component: <SprintList />,
            permission_needed: true,
        },
        name: 'Sprint List',
        type: 'Task Management',
    },
    task_dashboard_kanban: {
        view: {
            codenames: [],
            action_code: 'visible_task_dashboard_kanban_view',
            is_superuser_action: false,
            name: 'View My Tasks Kanban',
            label: 'My Tasks',
            action: 'sub-menu',
            url: '/task/dashboard/kanban',
            component: <TaskKanban />,
            permission_needed: true,
        },
        name: 'My Tasks',
        type: 'Task Management',
    },
    task_backlog_unassigned: {
        view: {
            codenames: [],
            action_code: 'visible_task_backlog_unassigned_view',
            is_superuser_action: false,
            name: 'View Backlog - Unassigned',
            label: 'Backlog - Unassigned',
            action: 'sub-menu',
            url: '/task/backlog/unassigned',
            component: <TaskBacklogUnassigned />,
            permission_needed: true,
        },
        name: 'Backlog - Unassigned',
        type: 'Task Management',
    },
    task_updates: {
        view: {
            codenames: [],
            action_code: 'visible_task_updates_view',
            is_superuser_action: false,
            name: 'View Task Updates',
            label: 'Task Updates',
            action: 'sub-menu',
            url: '/task/updates',
            component: <TaskUpdatesSprintList />,
            permission_needed: true,
            associated_urls: ['/task/updates/:sprintId', '/task/updates/:sprintId/'],
        },
        create: {
            codenames: [],
            action_code: 'visible_task_updates_entry_view',
            is_superuser_action: false,
            name: 'View Task Updates Entry',
            label: 'Task Updates Entry',
            action: 'action-url',
            url: '/task/updates/:sprintId',
            component: <TaskSprintDailyUpdates />,
            permission_needed: true,
        },
        name: 'Task Updates',
        type: 'Task Management',
    },
    task_sprint: {
        view: {
            codenames: [],
            action_code: 'visible_task_sprint_view',
            is_superuser_action: false,
            name: 'View Sprint Planning',
            label: 'Sprint Planning',
            action: 'sub-menu',
            url: '/task/sprint-planning',
            component: <SprintPlanning />,
            permission_needed: true,
        },
        name: 'Sprint Planning',
        type: 'Task Management',
    },
    sprint_updates: {
        view: {
            codenames: [],
            action_code: 'visible_sprint_updates_view',
            is_superuser_action: false,
            name: 'View Sprint Updates',
            label: 'Sprint Updates',
            action: 'sub-menu',
            url: '/task/sprint-updates',
            component: <SprintUpdatesReport />,
            permission_needed: true,
        },
        name: 'Sprint Updates',
        type: 'Task Management',
    },
    my_leaves: {
        view: {
            codenames: [],
            action_code: 'visible_my_leaves_view',
            is_superuser_action: false,
            name: 'View My Leaves',
            label: 'My Leaves',
            action: 'sub-menu',
            url: '/task/my-leaves',
            component: <MyLeaves />,
            permission_needed: true,
        },
        create: {
            codenames: [],
            action_code: 'visible_my_leaves_add',
            is_superuser_action: false,
            name: 'Mark My Leave',
            label: 'My Leaves',
            action: 'action',
            permission_needed: true,
        },
        name: 'My Leaves',
        type: 'Task Management',
    },
    leave_management: {
        view: {
            codenames: [],
            action_code: 'visible_leave_management_view',
            is_superuser_action: false,
            name: 'View Leave Management',
            label: 'Leave Management',
            action: 'sub-menu',
            url: '/task/leave-management',
            component: <LeaveManagement />,
            permission_needed: true,
        },
        name: 'Leave Management',
        type: 'Task Management',
    },
};

export default Actions;

